// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2GyP4","header":"ClearentDisclaimer_header__3S-E4","inner":"ClearentDisclaimer_inner__25d5j"};